import REBSCarousel from './components/rebs-carousel';

// Script for property detail pages
function initializeMobileContactBar() {
  let $actionViewing = $('.action-viewing');

  if ($actionViewing.length > 0) {
    $actionViewing.on('click', (event) => {
      // Hide contact bar
      let $contactBar = $(event.target).closest('.property-mobile-contact-bar')
      $contactBar.hide();

      // After a 1.5s delay, show the contact bar only if the form is not in view
      // (i.e. is intersecting >40% of the viewport)
      setTimeout(_ => {
        let form = document.querySelector($actionViewing.attr('href')),
            intersectOptions = {
              root: null, // Browser viewport
              threshold: 0.4 // >40% of target is visible => intersection
            },
            observer;

        observer = new IntersectionObserver((entries, observer) => {
          // Intersection callback
          if (entries[0].isIntersecting) { // True if form is intersecting the viewport
            $contactBar.hide();
          } else {
            $contactBar.show();
          }
        }, intersectOptions);

        // Start watching for the form to intersect viewport
        observer.observe(form);

      }, 1.5 * 1000);
    });
  }
}

function initializePropertyReadMore() {
  $('.property-description-read-more').on('click', (event) => {
    let $description = $(event.target).closest('.property-description');
    $description.removeClass('property-description-undiscovered');
    $(event.target).hide();
    event.preventDefault();
  });
}

/**
 * Initialize all visible carousels.
 */
function initializeCarousels() {
  let $carousel = $('.property-main-content .rebs-carousel');
  if ($carousel.length > 0) {
    new REBSCarousel($carousel.get(0), {keyboardSlide: true});
  }

  // initialize all other page carousels using lazy loading (next property carousels use lazy loading)
  $(document).on('lazybeforeunveil', function(e){
    $(e.target).find('.rebs-carousel').each(function(index, el) {
      new REBSCarousel(el, {
        enableFullscreen: false
      });
    });
  });
}

/**
 * Adds a negative margin bottom to sticky columns, equal to the height of a target element.
 * This allows the sticky column to scroll past that target element, even though they are not siblings.
 */
function initializeStickyMargins() {
  $('.property-column-sticky').each(function(index, el) {
    let $el = $(el);
    if ($el && $el.data('offset-target')) {
      let $offsetTarget = $($el.data('offset-target'));
      if ($offsetTarget) {
        $el.css('margin-bottom', - $offsetTarget.height());
      }
    }
  });
}

$(function () {
  initializeMobileContactBar();
  initializePropertyReadMore();
  initializeCarousels();
  initializeStickyMargins();
});
